import { Component } from '@angular/core';

@Component({
  selector: 'app-agent-accreditation',
  templateUrl: './agent-accreditation.component.html',
  styleUrl: './agent-accreditation.component.scss'
})
export class AgentAccreditationComponent {

}
